export const getRemainingTimeUntil6AM = () => {
  const now = new Date();
  const today6AM = new Date(now);
  today6AM.setHours(6, 0, 0, 0);

  // 기준 시간: 지금이 6시 전이면 오늘 6시, 아니면 내일 6시
  const target = now < today6AM ? today6AM : new Date(today6AM.getTime() + 24 * 60 * 60 * 1000);

  const diffMs = target.getTime() - now.getTime();
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

  return { hours, minutes };
};
